<!-- menu -->
<div class="mainmenu">
  <div class="usermenu">
    <ul class="listaprimera">
      <li class="avatar">
        <div class="ajustesC">
          <img src="/assets/img/cog2.svg" alt="ajustes" />
        </div>
        <img
          routerLink="/externo/profile/{{ uid }}/pass"
          *ngIf="avatar; else defaultheadavatar"
          src="{{ avatar }}"
        />

        <ng-template ng-template #defaultheadavatar
          ><img
            routerLink="/externo/profile/{{ uid }}/pass"
            src="assets/img/defaultavatar.jpg"
          />
        </ng-template>
      </li>

      <li>
        <a title="{{ 'dashboard.menu.notificaciones' | translate }}">
          <img src="/assets/img/bell.svg" alt="" />
        </a>
      </li>
      <li>
        <a routerLink="/externo" title="{{ 'dashboard.menu.home' | translate }}">
          <img src="/assets/img/home2.svg" alt="" />
        </a>
      </li>
    </ul>
  </div>

  <div class="utilities">
    <ul class="listasegunda">
      <li>
        <a (click)="open()" title="{{ 'dashboard.menu.clases' | translate }}">
          <img src="/assets/img/grupo.png" alt="" />
        </a>
      </li>
      <li>
        <a (click)="open()" title="{{ 'dashboard.menu.mensajes' | translate }}">
          <img src="/assets/img/chatbox.png" alt="" />
        </a>
      </li>
      <li>
        <a
          (click)="open()"
          title="{{ 'dashboard.menu.videocall' | translate }}"
        >
          <img src="/assets/img/videocall.png" alt="" />
        </a>
      </li>
      <li>
        <a (click)="open()" title="{{ 'dashboard.menu.eventos' | translate }}">
          <img src="/assets/img/calendar.png" alt="" />
        </a>
      </li>
      <li>
        <a (click)="open()" title="{{ 'dashboard.menu.archivos' | translate }}">
          <img src="/assets/img/folder.png" alt="" />
        </a>
      </li>
      <li>
        <a
          (click)="logout(uidb)"
          title="{{ 'dashboard.menu.logout' | translate }}"
        >
          <img src="/assets/img/logout.svg" alt="" />
        </a>
      </li>
    </ul>
  </div>

  <div class="manual">
    <ul class="listainfo">
      <li>
        <a title="{{ 'dashboard.menu.ayuda' | translate }}">
          <img src="/assets/img/informacion.png" alt="" />
        </a>
      </li>
    </ul>
  </div>
  <!-- /menu -->
</div>

<div class="overlay" *ngIf="show">
  <div class="popup">
    <h2>Esta herramienta no está disponible para su cuenta.</h2>
    <button class="button medium center" (click)="close()">Cerrar</button>
  </div>
</div>
